import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {configCategoriesEdit_template} from "../components/templates/configCategoriesEdit_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class config_categories_edit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected editForm: configCategoriesEdit_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    protected getModuleName(){

        return "config_categories_edit";
    }

    buildContent() : Array<Element>{

        this.editForm = new configCategoriesEdit_template("editForm", this.viewModel, this);
        return [this.editForm.build()];
    }

    public fillPage() : void{

        this.getCategory();
    }

    public cancelForm() {
        this.cancel();
    }

    protected cancel(){

        this.releaseLock();

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect('/brand/' + idBrand + "/categorization/categories");
    }

    protected getCategory(){

        this.loadingIn(this.editForm.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idCategory = this.getVnAppZone().getApp().params.idCategory;

        let usrReq_url: string = '/api/brand/' + idBrand + "/categories/get/"+idCategory;

        let usrReq_params: Array<Array<string>> = [];

        let vm = this.editForm.getViewModelForRequest();

        usrReq_params.push(["data", ko.toJSON({lockItem: true})] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){
                let responseParsed = JSON.parse(req.request.response);
                obj.setForm(responseParsed);
            });
            obj.loadingOut(obj.editForm.builtTemplate);

        }
    }

    protected setForm(responseParsed: any){

        this.editForm.setCategory(responseParsed.data)
    }


    protected filterSimpleOnChange(idElement) {
    }

    protected save(){

        this.loadingIn(this.editForm.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/categories/save";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = {
            editForm: this.editForm.getViewModelForRequest()
        };

        formReq_params.push(["data", ko.toJSON(subViewModel)]);
        //
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    obj.releaseLock();
                    page.redirect('/brand/' + idBrand + "/categorization/categories/");

                });
                obj.loadingOut(obj.editForm.builtTemplate);

            }
        });
        XHRHdl.execute();
    }


    protected releaseLock() {

        // request a lock release
        let idCategory = this.getVnAppZone().getApp().params.idCategory;

        let usrReq_url: string = '/api/brand/categories/release/'+idCategory;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.execute();
    }


    protected getImagePickerHelper() {
        return this.editForm.imagePickerHelper;
    }
}


// WEBPACK FOOTER //
// ./js/modules/config_categories_edit.ts